AFRAME.registerComponent('auto-orient-billboards', {
    init: function () {
        this.camera = document.getElementById('camera');
        if (!this.camera) {
            console.error('Camera not found for auto-orient-billboards!');
            return;
        }

        this.fullBillboards = new Set();
        this.xBillboards = new Set();

        const scene = this.el.sceneEl;

        const applyOrientation = (mutations) => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        if (node.classList?.contains('billboard')) {
                            this.fullBillboards.add(node);
                        }
                        if (node.classList?.contains('billboard-x')) {
                            this.xBillboards.add(node);
                        }
                    }
                });
                mutation.removedNodes.forEach(node => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        this.fullBillboards.delete(node);
                        this.xBillboards.delete(node);
                    }
                });
            });
        };

        // Observe DOM changes
        const observer = new MutationObserver(applyOrientation);
        observer.observe(scene, { childList: true, subtree: true });

        // Initialize existing entities
        document.querySelectorAll('.billboard').forEach(el => {
            this.fullBillboards.add(el);
        });
        document.querySelectorAll('.billboard-x').forEach(el => {
            this.xBillboards.add(el);
        });

        this.observer = observer;
    },

    tick: function () {
        const cameraWorldPos = new AFRAME.THREE.Vector3();
        this.camera.object3D.getWorldPosition(cameraWorldPos);

        // Handle full billboards
        this.fullBillboards.forEach(el => {
            el.object3D.lookAt(cameraWorldPos);
        });

        // Handle X-axis only billboards
        this.xBillboards.forEach(el => {
            const objectWorldPos = new AFRAME.THREE.Vector3();
            el.object3D.getWorldPosition(objectWorldPos);

            const direction = cameraWorldPos.clone().sub(objectWorldPos);
            const currentRotation = el.object3D.rotation;
            // Calculate X-axis rotation (up/down)
            const targetX = Math.atan2(direction.z, direction.y) - Math.PI/2;

            // Apply only the X-axis rotation
            el.object3D.rotation.set(targetX, currentRotation.y, currentRotation.z);
        });
    },

    remove: function () {
        if (this.observer) {
            this.observer.disconnect();
        }
    }
});